/* Tracking for the Christmas guides. fcTrack('name', {..}) publishes fc_<name> through Shopify's
   customer events (consent-aware; a custom pixel in Settings > Customer events forwards them to
   analytics) and pushes the same event to a GTM dataLayer if one exists. Every event carries the
   page, the mode and the device so weekly reports can split by them. */
window.fcTrack = function (name, props) {
  try {
    var X = window.fcXmas || {};
    var p = { page: location.pathname.replace(/^\/en-[a-z]{2}/, ''), mode: X.mode || '', device: window.innerWidth < 750 ? 'mobile' : 'desktop', country: X.country || '' };
    for (var k in props || {}) p[k] = props[k];
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('fc_' + name, p);
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'fc_' + name }, p));
    if (window.fcTrackDebug) console.log('[fcTrack]', 'fc_' + name, p);
  } catch (e) {}
};
/* Fun Cases — Christmas 2026
   1. Delivery cut-offs: one engine for the bar, product page, stocking and delivery table.
   2. Snow (light, respects reduced motion, pauses in background tabs).
   3. Stocking extras on top of cart.js: fill meter, gap-closing stocking fillers, gift note, gift box.
   4. Gift finder.
   5. Gift sets: add a whole set to the stocking in one go.
   Config comes from snippets/xmas-config.liquid (window.fcXmas). */
(function () {
  'use strict';
  var X = window.fcXmas;
  if (!X) return;

  var fmtMoney = window.__fcMoney || '£{{amount}}';
  function money(c) { return fmtMoney.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, (c / 100).toFixed(2)); }
  function esc(s) { return (s == null ? '' : '' + s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     1. Cut-offs. All cut-offs fall in November/December, when the UK is on
     GMT, so a UK wall-clock time is the same instant as UTC.
     ?xmas_now=2026-12-19T10:00 previews any moment.
  ------------------------------------------------------------------ */
  function parseUK(date, time) {
    var d = (date || '').split('-').map(Number), t = (time || '23:59').split(':').map(Number);
    if (d.length < 3 || !d[0]) return null;
    return new Date(Date.UTC(d[0], d[1] - 1, d[2], t[0] || 0, t[1] || 0, 59));
  }
  var forced = (location.search.match(/[?&]xmas_now=([^&]+)/) || [])[1];
  var offset = forced ? (new Date(decodeURIComponent(forced) + 'Z').getTime() - Date.now()) : 0;
  function now() { return new Date(Date.now() + offset); }

  var cutoffs = (X.cutoffs || []).map(function (c) { return { service: c.service, at: parseUK(c.date, c.time) }; })
    .filter(function (c) { return c.at; }).sort(function (a, b) { return a.at - b.at; });
  var xmasDay = new Date(Date.UTC(2026, 11, 25, 0, 0, 0));
  var afterEnd = parseUK(X.afterEnd || '2027-01-04', '23:59');

  /* Cut-offs stay hidden until they're switched on in Theme settings (or the automatic date arrives).
     ?xmas_cutoffs=1 previews them switched on. */
  var cutoffsFrom = X.cutoffsFrom ? parseUK(X.cutoffsFrom, '00:00') : null;
  var forceCutoffs = /[?&]xmas_cutoffs=1/.test(location.search);
  function cutoffsOn() { return X.cutoffsOn || forceCutoffs || !!(cutoffsFrom && now() >= cutoffsFrom); }
  function state() {
    var n = now();
    if (n < xmasDay && !cutoffsOn()) return { phase: 'early' };
    var open = cutoffs.filter(function (c) { return c.at > n; });
    if (open.length) return { phase: 'pre', next: open[0], open: open, closed: cutoffs.length - open.length };
    if (n < xmasDay) return { phase: 'late' };
    if (afterEnd && n <= afterEnd) return { phase: 'after' };
    return { phase: 'off' };
  }
  function dayLabel(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/London' });
  }
  function timeLabel(d) {
    var h = d.getUTCHours(), m = d.getUTCMinutes();
    if (h === 23 && m === 59) return '';
    return ' at ' + (h % 12 || 12) + (m ? ':' + (m < 10 ? '0' : '') + m : '') + (h < 12 ? 'am' : 'pm');
  }
  function left(ms) {
    var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
    if (d >= 1) return d + 'd ' + h + 'h ' + m + 'm';
    return h + 'h ' + (m < 10 ? '0' : '') + m + 'm ' + (s < 10 ? '0' : '') + s + 's';
  }
  /* One message, three lengths: short (bar on phones), long (bar on desktop, product page), stocking. */
  function message(st) {
    if (st.phase === 'early') {
      return X.earlyMsg ? { tone: 'calm', short: esc(X.earlyMsg), long: esc(X.earlyMsg), bar: true, stocking: '', link: X.earlyLink || '/pages/christmas' } : null;
    }
    if (st.phase === 'pre') {
      var c = st.next, ms = c.at - now();
      var when = dayLabel(c.at) + timeLabel(c.at);
      var svc = cutoffs.length > 1 ? ' with ' + c.service + ' delivery' : '';
      var urgent = ms < 3 * 864e5;
      return {
        tone: urgent ? 'urgent' : 'calm',
        short: urgent ? 'Christmas delivery: order within <b data-xmas-left>' + left(ms) + '</b>' : 'Order by <b>' + when + '</b> for Christmas',
        long: (st.closed ? c.service + ' still arrives for Christmas. ' : '') + 'Order by <b>' + when + '</b>' + svc + ' to get it before Christmas' + (urgent ? ' &middot; <b data-xmas-left>' + left(ms) + '</b> left' : ''),
        stocking: 'Order by <b>' + when + '</b>' + svc + ' and it arrives before Christmas.',
        link: X.deliveryUrl
      };
    }
    if (st.phase === 'late') {
      return { tone: 'late', short: 'Too late to post? Send a gift card', long: 'Too late for Christmas delivery. Our e-gift cards arrive by email in minutes', stocking: 'Delivery before Christmas has closed for your area. An e-gift card arrives by email in minutes.', link: X.giftCardUrl };
    }
    if (st.phase === 'after') {
      return { tone: 'calm', short: 'New phone for Christmas? Find its case', long: 'New phone for Christmas? Pick your model and see every case that fits', stocking: '', link: '#phone' };
    }
    return null;
  }

  function paintDeadlines() {
    var st = state(), m = message(st);
    document.documentElement.setAttribute('data-xmas-phase', st.phase);
    document.querySelectorAll('[data-xmas-msg]').forEach(function (el) {
      if (!m) { el.hidden = true; return; }
      var kind = el.getAttribute('data-xmas-msg') || 'long';
      if (m.bar && kind !== 'bar') { el.hidden = true; return; }
      el.innerHTML = kind === 'bar'
        ? '<span class="xbar__short">' + m.short + '</span><span class="xbar__long">' + m.long + '</span>'
        : (m[kind] || m.long);
      el.setAttribute('data-tone', m.tone);
      var a = el.closest('[data-xmas-link]');
      if (a && m.link) {
        if (m.link === '#phone') { a.setAttribute('href', '#'); a.setAttribute('data-phone-open', ''); }
        else { a.setAttribute('href', m.link); a.removeAttribute('data-phone-open'); }
      }
      el.hidden = !(kind === 'stocking' ? m.stocking : true);
    });
    /* Delivery table rows: mark passed services, highlight the one to use now. */
    document.querySelectorAll('[data-xmas-row]').forEach(function (row) {
      var at = parseUK(row.getAttribute('data-date'), row.getAttribute('data-time'));
      if (!at) return;
      var passed = at <= now();
      row.classList.toggle('is-passed', passed);
      row.classList.toggle('is-next', !!(st.next && !passed && Math.abs(at - st.next.at) < 1000));
      var stEl = row.querySelector('[data-xmas-row-state]');
      if (stEl) stEl.textContent = passed ? 'Closed' : (st.next && Math.abs(at - st.next.at) < 1000 ? 'Order now' : 'Open');
    });
    return st;
  }
  /* Repaint when the phase, the active cut-off or the urgency changes; otherwise just tick the clock. */
  var lastKey = '';
  function tick() {
    var st = state();
    var urgent = !!(st.next && st.next.at - now() < 3 * 864e5);
    var key = st.phase + (st.next ? st.next.at.getTime() : '') + urgent;
    if (key !== lastKey) { lastKey = key; paintDeadlines(); }
    if (urgent) {
      var txt = left(st.next.at - now());
      document.querySelectorAll('[data-xmas-left]').forEach(function (el) { el.textContent = txt; });
    }
  }
  window.fcXmasState = state;
  window.fcXmasPaint = paintDeadlines;

  /* ------------------------------------------------------------------
     2. Snow. A single canvas behind nothing interactive (pointer-events none).
  ------------------------------------------------------------------ */
  function snow() {
    if (!X.snow || reduced) return;
    var c = document.createElement('canvas');
    c.className = 'xsnow'; c.setAttribute('aria-hidden', 'true');
    document.body.appendChild(c);
    var ctx = c.getContext('2d'), flakes = [], W, H, dpr = Math.min(window.devicePixelRatio || 1, 2), run = true;
    function size() { W = window.innerWidth; H = Math.round(window.innerHeight * 1.15); c.width = W * dpr; c.height = H * dpr; c.style.height = H + 'px'; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size();
    /* Phones resize the viewport as the address bar shows and hides; only rebuild the canvas when the
       width changes or the height changes a lot, otherwise the snow flickers on every scroll. */
    window.addEventListener('resize', function () {
      if (window.innerWidth !== W || window.innerHeight > H) size();
    });
    var count = W < 700 ? 14 : 30;
    for (var i = 0; i < count; i++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: 1 + Math.random() * 2, s: .25 + Math.random() * .6, w: Math.random() * 6.28 });
    function frame() {
      if (!run) return;
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = 'rgba(255,255,255,.7)';
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.s; f.w += .01; f.x += Math.sin(f.w) * .35;
        if (f.y > H + 4) { f.y = -4; f.x = Math.random() * W; }
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill();
      }
      requestAnimationFrame(frame);
    }
    document.addEventListener('visibilitychange', function () { run = !document.hidden; if (run) frame(); });
    frame();
  }

  /* ------------------------------------------------------------------
     3. Stocking extras. cart.js renders the lines; we add the rest after
     every render (it fires fc:cart:rendered).
  ------------------------------------------------------------------ */
  var drawer = document.querySelector('[data-cart-drawer]');
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) { try { if (window.fcAddedToCart && res.items) window.fcAddedToCart(res.items[0]); } catch (e) {} return res; });
  }

  function stockingRender(cart) {
    if (!drawer || !X.stocking) return;
    var shipT = parseInt(drawer.dataset.shipThreshold, 10) || 0, giftT = parseInt(drawer.dataset.giftThreshold, 10) || 0;
    var shipOn = drawer.dataset.shipEnabled === '1', giftOn = drawer.dataset.giftEnabled === '1';
    var total = cart.total_price || 0;
    var goals = [];
    if (shipOn && shipT) goals.push(shipT);
    if (giftOn && giftT) goals.push(giftT);
    var top = goals.length ? Math.max.apply(null, goals) : 2500;

    /* Fill meter in the header stocking icon */
    var pct = cart.item_count ? Math.max(.12, Math.min(1, total / top)) : 0;
    drawer.querySelectorAll('[data-stocking-fill]').forEach(function (r) { r.setAttribute('transform', 'translate(0 ' + (100 - pct * 100).toFixed(1) + ')'); });
    drawer.classList.toggle('is-full', pct >= 1);
    var countEl = drawer.querySelector('[data-stocking-count]');
    if (countEl) countEl.textContent = cart.item_count ? cart.item_count + (cart.item_count === 1 ? ' gift' : ' gifts') : '';

    /* Deadline line */
    paintDeadlines();

    /* Stocking fillers: the cheapest filler that closes the nearest unmet goal leads. */
    var slot = drawer.querySelector('[data-stocking-fillers]');
    if (slot) {
      var inCart = {}; (cart.items || []).forEach(function (i) { inCart[i.variant_id] = true; inCart['p' + i.product_id] = true; });
      var model = (cart.attributes && cart.attributes.phone_model) || '';
      /* Model-specific add-ons (screen protectors) resolve to the shopper's saved phone, so they can be one-tap. */
      var list = (X.fillers || []).map(function (f) {
        if (f.models && model && f.models[model]) return Object.assign({}, f, { id: f.models[model], multi: false, forModel: model });
        return f;
      }).filter(function (f) { return f.available && !inCart[f.id] && !inCart['p' + f.pid]; });
      var unmet = goals.filter(function (g) { return g > total; }).sort(function (a, b) { return a - b; });
      var gap = unmet.length ? unmet[0] - total : 0;
      if (gap > 0) {
        list.sort(function (a, b) {
          var ca = a.price >= gap, cb = b.price >= gap;
          if (ca !== cb) return ca ? -1 : 1;
          return ca ? a.price - b.price : b.price - a.price;
        });
      }
      list = list.slice(0, 4);
      if (!cart.item_count || !list.length) { slot.hidden = true; slot.innerHTML = ''; }
      else {
        var head = gap > 0 ? 'Stocking fillers. ' + money(gap) + ' more unlocks ' + (unmet[0] === shipT && shipOn ? 'free delivery' : 'a free gift') : 'Stocking fillers';
        slot.innerHTML = '<p class="xfill__head">' + head + '</p><div class="xfill__row">' + list.map(function (f) {
          var closes = gap > 0 && f.price >= gap;
          return '<div class="xfill' + (closes ? ' xfill--closes' : '') + '">' +
            '<a class="xfill__img" href="' + f.url + '">' + (f.image ? '<img src="' + f.image + '" alt="" loading="lazy">' : '') + '</a>' +
            '<a class="xfill__title" href="' + f.url + '">' + esc(f.title) + '</a>' + (f.forModel ? '<span class="xfill__fit">Fits ' + esc(f.forModel) + '</span>' : '') +
            '<span class="xfill__price">' + money(f.price) + '</span>' +
            (f.multi ? '<a class="xfill__add" href="' + f.url + '">Choose</a>' : '<button type="button" class="xfill__add" data-xfill-add="' + f.id + '">Add</button>') +
          '</div>';
        }).join('') + '</div>';
        slot.hidden = false;
      }
      /* One upsell row is enough: the generic related-products list steps aside while fillers show. */
      var recs = drawer.querySelector('[data-cart-recs]');
      if (recs) recs.classList.toggle('xrecs-off', !slot.hidden);
    }

    /* Gift box + gift note (static slot, filled once, kept in sync) */
    var extras = drawer.querySelector('[data-stocking-extras]');
    if (extras) {
      if (!cart.item_count) { extras.hidden = true; }
      else {
        extras.hidden = false;
        var gb = X.giftBox, gbWrap = extras.querySelector('[data-giftbox]');
        if (gbWrap) {
          var has = gb && (cart.items || []).some(function (i) { return i.variant_id === gb.id; });
          gbWrap.hidden = !gb || has;
          /* A quiet one-line add-on, not a product card. */
          if (gb && !has) gbWrap.innerHTML = '<button type="button" class="xgiftbox__add" data-xfill-add="' + gb.id + '">+ Add a gift box <span class="xgiftbox__price">' + money(gb.price) + '</span></button>';
        }
        var note = extras.querySelector('[data-gift-note]');
        if (note && document.activeElement !== note && !note.dataset.dirty) note.value = cart.note || '';
      }
    }
  }

  var noteTimer;
  document.addEventListener('input', function (e) {
    var n = e.target.closest && e.target.closest('[data-gift-note]');
    if (!n) return;
    n.dataset.dirty = '1';
    clearTimeout(noteTimer);
    var status = n.parentNode.querySelector('[data-gift-note-status]');
    if (status) status.textContent = '';
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: n.value }) })
        .then(function () { delete n.dataset.dirty; if (status) status.textContent = 'Saved'; });
    }, 600);
  });

  document.addEventListener('fc:cart:rendered', function (e) { stockingRender(e.detail && e.detail.cart || { items: [], item_count: 0, total_price: 0 }); });

  /* ------------------------------------------------------------------
     Click handling: filler quick-add, gift sets, gift finder.
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var fa = e.target.closest('[data-xfill-add]');
    if (fa) {
      e.preventDefault(); fa.disabled = true; fa.classList.add('is-loading');
      addItems([{ id: +fa.getAttribute('data-xfill-add'), quantity: 1 }]).then(function () { if (window.fcCart) window.fcCart.refresh(); }, function () { fa.disabled = false; fa.classList.remove('is-loading'); });
      return;
    }
    var sb = e.target.closest('[data-set-add]');
    if (sb) {
      e.preventDefault();
      var items = []; try { items = JSON.parse(sb.getAttribute('data-set-add')) || []; } catch (er) {}
      if (!items.length) return;
      sb.disabled = true; sb.classList.add('is-loading');
      var label = sb.innerHTML;
      addItems(items.map(function (id) { return { id: id, quantity: 1 }; }))
        .then(function () { sb.innerHTML = 'Added to your stocking'; if (window.fcCart) window.fcCart.open(); setTimeout(function () { sb.innerHTML = label; sb.disabled = false; sb.classList.remove('is-loading'); }, 2500); })
        .catch(function (err) { sb.innerHTML = (err && err.description) || 'Could not add the set'; setTimeout(function () { sb.innerHTML = label; sb.disabled = false; sb.classList.remove('is-loading'); }, 3000); });
      return;
    }
    var gfOpt = e.target.closest('[data-gf-opt]');
    if (gfOpt) { e.preventDefault(); finderPick(gfOpt); return; }
    var gfBack = e.target.closest('[data-gf-back]');
    if (gfBack) { e.preventDefault(); finderStep(gfBack.closest('[data-gift-finder]'), +gfBack.getAttribute('data-gf-back')); return; }
  });

  /* ------------------------------------------------------------------
     4. Gift finder. Three taps: who, what they're into, budget.
     Results come from the Section Rendering API (collection + product-type
     filters applied by Shopify, market prices included), budget filtered here.
  ------------------------------------------------------------------ */
  /* Budgets are set in pounds; gift-finder.liquid outputs them in the shopper's currency. */
  function finderStep(root, n) {
    if (!root) return;
    root.querySelectorAll('[data-gf-step]').forEach(function (s) { s.hidden = +s.getAttribute('data-gf-step') !== n; });
    root.setAttribute('data-gf-at', n);
    var dots = root.querySelectorAll('[data-gf-dot]');
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i <= n); });
  }
  function finderPick(btn) {
    var root = btn.closest('[data-gift-finder]');
    var step = +btn.closest('[data-gf-step]').getAttribute('data-gf-step');
    var key = btn.getAttribute('data-gf-key');
    root['gf_' + key] = { value: btn.getAttribute('data-gf-opt'), label: btn.getAttribute('data-gf-label') || btn.textContent.trim(), types: btn.getAttribute('data-gf-types') || '', guide: btn.getAttribute('data-gf-guide') || '' };
    window.fcTrack('finder_step', { step: step + 1, question: key, answer: root['gf_' + key].label });
    btn.parentNode.querySelectorAll('[data-gf-opt]').forEach(function (b) { b.classList.toggle('is-picked', b === btn); });
    if (step < 2) { finderStep(root, step + 1); return; }
    finderResults(root);
  }
  function finderResults(root) {
    finderStep(root, 3);
    var who = root.gf_who || {}, vibe = root.gf_vibe || {}, budget = root.gf_budget || {};
    var out = root.querySelector('[data-gf-results]'), sum = root.querySelector('[data-gf-summary]'), more = root.querySelector('[data-gf-more]');
    if (sum) sum.textContent = [who.label, vibe.label, budget.label].filter(Boolean).join(' · ');
    out.innerHTML = '<div class="gf-loading"><span class="ps-spinner"></span></div>';
    var types = (who.types || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var qs = types.map(function (t) { return 'filter.p.product_type=' + encodeURIComponent(t); }).join('&');
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'collections/' + (vibe.value || 'trending');
    var max = parseInt(budget.value, 10) || 0;   // already in the shopper's currency, in cents (see gift-finder.liquid)
    var url = base + '?section_id=gift-finder-results' + (qs ? '&' + qs : '');
    var seeAll = base + (qs ? '?' + qs : '');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-gf-card]'));
      var all = cards.slice(), over = [];
      function price(c) { return +c.getAttribute('data-price') || 0; }
      if (max) {
        cards = cards.filter(function (c) { return price(c) <= max; });
        /* Tight budgets (Under £10 with some interests) can leave 0-3 gifts: top up with the closest prices just over. */
        if (cards.length < 4) over = all.filter(function (c) { return price(c) > max; }).sort(function (a, b) { return price(a) - price(b); }).slice(0, 8 - cards.length);
      }
      /* Phone cases first: they are the highest-margin gift. Array sort is stable, so the collection order holds within each group. */
      cards.sort(function (a, b) { return (b.hasAttribute('data-case') ? 1 : 0) - (a.hasAttribute('data-case') ? 1 : 0); });
      cards = cards.slice(0, 8);
      window.fcTrack('finder_results', { who: who.label || '', interest: vibe.label || '', budget: budget.label || '', results: cards.length, over_budget: over.length });
      if (!cards.length && !over.length) {
        out.innerHTML = '<p class="gf-empty">Nothing in that exact mix right now. Try a bigger budget or another interest' + (who.guide ? ', or browse the <a href="' + who.guide + '">full gift guide</a>' : '') + '.</p>';
      } else {
        out.innerHTML = '';
        if (!cards.length) out.insertAdjacentHTML('beforeend', '<p class="gf-overnote">Nothing in that budget right now. These are the closest:</p>');
        cards.forEach(function (c) { out.appendChild(document.importNode(c, true)); });
        if (over.length && cards.length) out.insertAdjacentHTML('beforeend', '<p class="gf-overnote">Just over budget</p>');
        over.forEach(function (c) { var n = document.importNode(c, true); n.classList.add('gf-card--over'); out.appendChild(n); });
      }
      if (more) {
        var links = '<a class="btn btn-ghost" href="' + seeAll + '">See more like this &rarr;</a>';
        if (who.guide) links += '<a class="btn btn-sun" href="' + who.guide + '">' + esc(who.label) + ' gift guide &rarr;</a>';
        more.innerHTML = links;
      }
    }).catch(function () { out.innerHTML = '<p class="gf-empty">Could not load gifts. <a href="' + seeAll + '">See them here</a>.</p>'; });
  }

  /* ------------------------------------------------------------------ */
  function init() {
    tick();
    setInterval(tick, 1000);
    snow();
    document.querySelectorAll('[data-gift-finder]').forEach(function (r) { finderStep(r, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { paintDeadlines(); document.querySelectorAll('[data-gift-finder]').forEach(function (r) { if (!r.getAttribute('data-gf-at')) finderStep(r, 0); }); });
})();

/* ------------------------------------------------------------------
   Christmas mode switch + transition.
   Click: the knob slides, a circle of the new mode sweeps out from the switch with a burst of
   snow (or confetti going back to everyday), the choice is saved as the cart attribute
   _christmas_mode, and the page reloads in the new mode. The reloaded page starts covered
   (layout/theme.liquid) and this script opens it up. Reduced motion: no animation.
------------------------------------------------------------------ */
(function () {
  'use strict';
  var X = window.fcXmas;
  if (!X) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Top layer (popover) sits above every z-index, including cookie banners and app popups. */
  function topLayer(o) {
    try { if (o.showPopover) { o.setAttribute('popover', 'manual'); o.showPopover(); } } catch (e) {}
  }
  function track(state) {
    window.fcTrack('mode_switch', { to: state });
    try { var k = window.klaviyo || window._learnq; if (k && k.push) k.push(['track', 'Christmas Mode', { State: state }]); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-fc-switch]');
    if (!sw || sw.dataset.busy) return;
    document.querySelectorAll('[data-fc-tip]').forEach(function (t) { t.hidden = true; });
    e.preventDefault();
    sw.dataset.busy = '1';
    var turningOn = sw.getAttribute('aria-checked') !== 'true';
    var to = turningOn ? 'christmas' : 'everyday';
    sw.setAttribute('aria-checked', turningOn ? 'true' : 'false');
    track(turningOn ? 'on' : 'off');

    var save = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _christmas_mode: turningOn ? 'on' : 'off' } }) }).catch(function () {});

    /* The scroll position travels with the reload (restored by the hook at the top of <body>). */
    try { sessionStorage.setItem('fcReveal', JSON.stringify({ to: to, s: Math.round(window.scrollY), quiet: !!reduced, t: Date.now() })); } catch (e2) {}
    if (reduced) { save.then(function () { location.reload(); }); return; }
    var o = document.createElement('div');
    o.className = 'fcx fcx--' + to; o.setAttribute('aria-hidden', 'true');
    o.innerHTML = window.__fcxHTML ? window.__fcxHTML(to) : '';
    document.body.appendChild(o);
    topLayer(o);
    o.getBoundingClientRect();                       // commit the open position before closing
    setTimeout(function () { o.classList.add('is-closed'); }, 260);   // let the knob land first

    var minTime = new Promise(function (res) { setTimeout(res, 1700); });   // curtains shut + projection in focus
    Promise.all([save, minTime]).then(function () { location.reload(); });
  });

  /* Arriving after a switch: open the new page up. */
  function reveal() {
    var o = document.getElementById('fcx'), r = window.__fcReveal;
    if (!o || !r) return;
    topLayer(o);
    /* Runs once the HTML is parsed (deferred script); images keep loading underneath. */
    setTimeout(function () {
      if (window.__fcKeepScroll) window.__fcKeepScroll();
      document.documentElement.classList.add('fcx-revealed');
      o.classList.add('is-opening'); o.classList.remove('is-full');
      setTimeout(function () { o.classList.add('is-gone'); }, 1250);
      setTimeout(function () { o.remove(); document.documentElement.classList.remove('fcx-revealing'); }, 1550);
      setTimeout(function () { document.documentElement.classList.remove('fcx-revealed'); }, 2800);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();

  /* First visit in everyday mode: the switch glows twice so people notice it. */
  setTimeout(function () {
    if (X.mode !== 'everyday' || reduced) return;
    try { if (localStorage.getItem('fc_sw_seen')) return; localStorage.setItem('fc_sw_seen', '1'); } catch (e) { return; }
    document.querySelectorAll('[data-fc-switch]').forEach(function (b) { b.classList.add('is-nudge'); });
    var tip = [].filter.call(document.querySelectorAll('[data-fc-tip]'), function (t) { return t.parentNode.offsetParent; })[0];
    if (tip) {
      tip.hidden = false;
      var hide = function () { tip.hidden = true; removeEventListener('scroll', onScroll); };
      var onScroll = function () { if (scrollY > 200) hide(); };
      addEventListener('scroll', onScroll, { passive: true });
      tip.addEventListener('click', function () { var b = tip.parentNode.querySelector('[data-fc-switch]'); hide(); if (b) b.click(); });
      setTimeout(hide, 5000);
    }
  }, 1500);
})();

/* Menu drawer: its top padding is fixed for a page with no top bar. With the Christmas mode bar
   above the header, start the drawer just below wherever the header ends right now (the bar may
   be scrolled away), so the header never covers the menu. */
(function () {
  'use strict';
  var drawer = document.querySelector('.drawer');
  var header = document.querySelector('.site-header');
  if (!drawer || !header || !document.querySelector('.xbar')) return;
  function place() {
    if (!document.body.classList.contains('nav-open')) { drawer.style.paddingTop = ''; return; }
    var gap = window.innerWidth >= 1081 ? 28 : 24;
    drawer.style.paddingTop = Math.round(header.getBoundingClientRect().bottom + gap) + 'px';
  }
  new MutationObserver(place).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', place);
})();

/* Collection gift guide band: arrows step through the chips; hidden when everything fits. */
(function () {
  'use strict';
  var band = document.querySelector('.xcband'); if (!band) return;
  var track = band.querySelector('[data-xcband-track]');
  var prev = band.querySelector('[data-xcband-step="-1"]'), next = band.querySelector('[data-xcband-step="1"]');
  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    band.classList.toggle('is-fits', max <= 2);
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }
  band.addEventListener('click', function (e) {
    var b = e.target.closest('[data-xcband-step]'); if (!b) return;
    track.scrollBy({ left: +b.getAttribute('data-xcband-step') * Math.max(160, track.clientWidth * .7), behavior: 'smooth' });
  });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();

/* Header lights fold away once the page scrolls (html.fc-scrolled). */
(function () {
  'use strict';
  if (!document.querySelector('.xhead-lights')) return;
  var on = null;
  function check() { var s = window.scrollY > 24; if (s !== on) { on = s; document.documentElement.classList.toggle('fc-scrolled', s); } }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();

/* Floating "Find a gift" button: opens the 3-step gift finder in a dialog. The little x hides
   it for a few days (per browser). Old links to #gift-finder open it too. */
(function () {
  'use strict';
  var pop = document.querySelector('[data-gfpop]'); if (!pop) return;
  var dlg = pop.querySelector('[data-gfpop-dlg]');
  var KEY = 'fc_gf_hidden', DAYS = 3;
  var hidden = false;
  try { var t = +localStorage.getItem(KEY); hidden = t && Date.now() - t < DAYS * 864e5; } catch (e) {}
  pop.hidden = false;
  if (hidden) pop.classList.add('is-hidden'); else setTimeout(function () { pop.classList.add('is-in'); }, 1200);
  function track(ev) { window.fcTrack(ev.replace(/^gift_/, ''), {}); }
  function open() {
    if (!dlg) return;
    pop.classList.remove('is-hidden'); pop.classList.add('is-in');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('gfpop-open');
    track('gift_finder_open');
  }
  function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  if (dlg) dlg.addEventListener('close', function () { document.documentElement.classList.remove('gfpop-open'); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gfpop-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-gfpop-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-gfpop-hide]')) {
      e.preventDefault(); pop.classList.add('is-hidden');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e2) {}
      track('gift_finder_hide'); return;
    }
    var a = e.target.closest('a[href$="#gift-finder"]');
    if (a) { e.preventDefault(); open(); return; }
    if (dlg && e.target === dlg) close();   // click on the backdrop
  });
})();

/* Gift bundle builder (sections/gift-bundle.liquid + sections/bundle-picker.liquid). */
(function () {
  'use strict';
  var root = document.querySelector('[data-gbun]'); if (!root) return;
  var fmt = window.__fcMoney || '£{{amount}}';
  function money(c) { return fmt.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, (c / 100).toFixed(2)).replace(/<[^>]+>/g, ''); }
  var stepPick = root.querySelector('[data-gbun-step="pick"]'), stepBuild = root.querySelector('[data-gbun-step="build"]');
  var list = root.querySelector('[data-gbun-slots]'), dlg = root.querySelector('[data-gbun-dlg]');
  var grid = dlg.querySelector('[data-gbun-grid]'), more = dlg.querySelector('[data-gbun-more]');
  var addBtn = root.querySelector('[data-gbun-add]'), hint = root.querySelector('[data-gbun-hint]');
  var bundle = null, slots = [], active = -1, nextUrl = null;
  var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function variant(s) { return s.item && (s.item.v.filter(function (v) { return v.id === s.vid; })[0] || s.item.v[0]); }
  /* Phone cases follow the product page: sides are chosen on Standard cases, Bumper and Standard
     MagSafe quietly send the default side, full-wrap types (Tough, Snap, MagSafe Tough) send none. */
  var SIDES = ['black', 'clear', 'white'];
  function sideOos(s) { return String(s.item.soos || '').split(',').filter(Boolean); }
  function sideMode(s) {
    var v = variant(s); if (!s.item.sides || !v) return 'none';
    if (/tough|snap/i.test(v.t)) return 'none';
    if (/bumper|magsafe/i.test(v.t)) return 'quiet';
    return 'choose';
  }
  function defaultSide(s) {
    var oos = sideOos(s), d = s.item.sdef || 'black';
    if (oos.indexOf(d) < 0) return d;
    return SIDES.filter(function (c) { return oos.indexOf(c) < 0; })[0] || '';
  }
  function cap(w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }
  function slotOk(s) { var v = variant(s); if (!s.item || !v) return false; return !(sideMode(s) === 'choose' && !s.side); }

  function phoneOpts(s, i) {
    var out = '<span class="gset-item__meta">For ' + esc((variant(s).p || {}).Phone || '') + '</span>';
    if (s.item.v.length > 1) {
      out += '<label class="gbun-opt"><span>Case type</span><select class="gset-item__sel" data-gbun-var="' + i + '">' +
        s.item.v.map(function (o) { return '<option value="' + o.id + '"' + (o.id === s.vid ? ' selected' : '') + '>' + esc(o.t) + ' &middot; ' + money(o.c) + '</option>'; }).join('') + '</select></label>';
    } else if (variant(s).t && variant(s).t !== 'Standard') {
      out += '<span class="gset-item__meta">' + esc(variant(s).t) + ' case</span>';
    }
    if (sideMode(s) === 'choose') {
      var oos = sideOos(s);
      out += '<div class="gbun-sides" role="radiogroup" aria-label="Case sides"><span>Sides</span>' + SIDES.map(function (c) {
        var off = oos.indexOf(c) > -1;
        return '<button type="button" class="gbun-side gbun-side--' + c + (s.side === c ? ' is-on' : '') + '" data-gbun-side="' + i + ':' + c + '"' + (off ? ' disabled title="Out of stock for this phone"' : '') + ' role="radio" aria-checked="' + (s.side === c) + '"><i></i>' + cap(c) + '</button>';
      }).join('') + '</div>';
    }
    return out;
  }

  function render() {
    list.innerHTML = slots.map(function (s, i) {
      var v = variant(s), body;
      if (!s.item) {
        body = (s.img ? '<span class="gbun-slot__img gbun-slot__img--ghost"><img src="' + s.img + '" alt="" width="80" height="80"></span>' : '') +
          '<span class="gbun-slot__info"><span class="gbun-slot__empty">Pick any ' + esc(s.label.toLowerCase()) + ' design</span>' +
          '<button type="button" class="gbun-slot__choose" data-gbun-choose="' + i + '">Choose a design &rarr;</button></span>';
      } else {
        var sel = s.item.pc ? phoneOpts(s, i) : (!s.item.single && s.item.v.length > 1)
          ? '<select class="gset-item__sel" data-gbun-var="' + i + '" aria-label="Options">' + s.item.v.map(function (o) { return '<option value="' + o.id + '"' + (o.id === s.vid ? ' selected' : '') + '>' + esc(o.t) + '</option>'; }).join('') + '</select>'
          : (s.item.v[0] && s.item.v[0].p && s.item.v[0].p.Phone ? '<span class="gset-item__meta">For ' + esc(s.item.v[0].p.Phone) + '</span>' : '');
        body = '<span class="gbun-slot__img"><img src="' + s.item.img + '" alt="" width="80" height="80"></span>' +
          '<span class="gbun-slot__info"><span class="gbun-slot__name">' + esc(s.item.title) + '</span>' + sel +
          '<button type="button" class="gbun-slot__change" data-gbun-choose="' + i + '">Change design</button></span>' +
          '<span class="gbun-slot__price">' + money(v ? v.c : 0) + '</span>';
      }
      return '<li class="gbun-slot' + (s.item ? ' is-set' : '') + '"' + (s.item ? '' : ' data-gbun-choose="' + i + '"') + '><span class="gbun-slot__n">' + (i + 1) + '</span><div class="gbun-slot__main"><p class="gbun-slot__label">' + esc(s.label) + (s.alt ? ' <small>' + (s.item ? (s.useAlt ? '(kids)' : '(adult)') : '(adult or kids)') + '</small>' : '') + (s.lock ? ' <small>(' + esc(s.lock) + ' case)</small>' : '') + '</p><div class="gbun-slot__row">' + body + '</div></div></li>';
    }).join('');
    var done = slots.every(slotOk);
    var sub = slots.reduce(function (t, s) { var v = variant(s); return t + (v ? v.c : 0); }, 0);
    var save = (bundle && bundle.code && slots.every(function (s) { return s.item; })) ? Math.min(bundle.saving || 0, sub) : 0;   // fixed amount, once every item is chosen
    var sr = root.querySelector('[data-gbun-saverow]'); if (sr) sr.hidden = !(bundle && bundle.code && bundle.saving);
    root.querySelector('[data-gbun-sub]').textContent = sub ? money(sub) : '–';
    var sv = root.querySelector('[data-gbun-save]'); if (sv) sv.textContent = bundle && bundle.saving ? '-' + money(bundle.saving) : '–';
    root.querySelector('[data-gbun-total]').textContent = sub ? money(sub - save) : '–';
    addBtn.disabled = !done;
    var setN = slots.filter(function (s) { return s.item; }).length;
    var bar = root.querySelector('[data-gbun-bar]'); if (bar) bar.style.width = (slots.length ? setN / slots.length * 100 : 0) + '%';
    var cnt = root.querySelector('[data-gbun-count]'); if (cnt) cnt.textContent = setN + ' of ' + slots.length + ' chosen';
    var sl = root.querySelector('[data-gbun-sumlist]');
    if (sl) sl.innerHTML = slots.map(function (s) { var v = variant(s); return '<li class="' + (s.item ? 'is-set' : '') + '"><span>' + esc(s.label) + '</span><span>' + (s.item ? money(v ? v.c : 0) : 'Not chosen') + '</span></li>'; }).join('');
    var mt = root.querySelector('[data-gbun-mtotal]'); if (mt) mt.textContent = sub ? money(sub - save) : '–';
    var a2 = root.querySelector('[data-gbun-add2]'); if (a2) a2.disabled = !done;
    var left = slots.filter(function (s) { return !s.item; }).length;
    var noSide = slots.some(function (s) { return s.item && sideMode(s) === 'choose' && !s.side; });
    hint.textContent = done ? '' : (noSide ? 'This case is out of stock in every side colour for your phone. Pick another case type or design.' : (left === slots.length ? 'Choose a design for each item.' : left + ' more to choose.'));
  }

  function start(b) {
    bundle = b; slots = b.slots.map(function (s) { return { label: s.label, type: s.type, coll: s.coll || 'all', img: s.img || '', lock: s.lock || '', alt: s.alt || null, useAlt: false, item: null, vid: null }; });
    root.querySelector('[data-gbun-btitle]').textContent = b.title;
    stepPick.hidden = true; stepBuild.hidden = false; root.classList.add('is-building'); render();
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
  }

  function load(url, append) {
    if (!append) grid.innerHTML = '<div class="gf-loading"><span class="ps-spinner"></span></div>';
    more.hidden = true;
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = doc.querySelectorAll('[data-bp-card]');
      if (!append) grid.innerHTML = '';
      var lock = active > -1 ? slots[active].lock : '';
      cards.forEach(function (c) {
        if (lock) {   // case-type bundles only offer designs made in that case type
          try { var it = JSON.parse(c.getAttribute('data-item')); if (!it.phone && !it.v.some(function (v) { return v.t === lock; })) return; } catch (err) { return; }
        }
        var node = document.importNode(c, true);
        if (/tough/i.test(lock)) {   // show the Tough mockup, not the Standard photo
          try { var ti = JSON.parse(node.getAttribute('data-item')); var tu = /magsafe/i.test(lock) ? (ti.mtimg || ti.timg) : ti.timg; if (tu) node.querySelector('.bpick__img img').src = tu; } catch (err) {}
        }
        grid.appendChild(node);
      });
      if (!grid.children.length) grid.innerHTML = '<p class="gf-empty">No designs found. Try another search.</p>';
      var n = doc.querySelector('[data-bp-next]');
      nextUrl = n ? n.getAttribute('data-bp-next') : null;
      more.hidden = !nextUrl;
    }).catch(function () { grid.innerHTML = '<p class="gf-empty">Could not load designs. Please try again.</p>'; });
  }
  function pickerUrl(s, q) {
    var type = s.useAlt && s.alt ? s.alt.type : s.type, coll = s.useAlt && s.alt ? (s.alt.coll || s.coll) : s.coll;
    var t = 'filter.p.product_type=' + encodeURIComponent(type);
    return q ? root_ + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&' + t + '&section_id=bundle-picker'
             : root_ + 'collections/' + coll + '?sort_by=best-selling&' + t + '&section_id=bundle-picker';
  }
  function openPicker(i) {
    active = i; var s = slots[i];
    window.fcTrack('bundle_picker_open', { bundle: bundle.title, item: s.label });
    dlg.querySelector('[data-gbun-dlgtitle]').textContent = 'Choose a design: ' + s.label;
    dlg.querySelector('[data-gbun-search] input').value = '';
    dlg.querySelectorAll('[data-gbun-chip]').forEach(function (c, n) { c.classList.toggle('is-on', n === 0); });
    var aw = dlg.querySelector('[data-gbun-altwrap]');
    if (aw) { aw.hidden = !s.alt; aw.querySelectorAll('[data-gbun-alt]').forEach(function (b) { b.classList.toggle('is-on', (b.getAttribute('data-gbun-alt') === '1') === !!s.useAlt); }); }
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('gfpop-open');
    load(pickerUrl(s));
  }
  function closePicker() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  dlg.addEventListener('close', function () { document.documentElement.classList.remove('gfpop-open'); });

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gbun-bundle]');
    if (b) { try { var bj = JSON.parse(b.getAttribute('data-gbun-bundle')); window.fcTrack('bundle_select', { bundle: bj.title, position: [].indexOf.call(b.parentNode.children, b) + 1 }); start(bj); } catch (err) {} return; }
    if (e.target.closest('[data-gbun-back]')) { stepBuild.hidden = true; stepPick.hidden = false; root.classList.remove('is-building'); return; }
    var alt = e.target.closest('[data-gbun-alt]');
    if (alt && active > -1) {
      slots[active].useAlt = alt.getAttribute('data-gbun-alt') === '1';
      dlg.querySelectorAll('[data-gbun-alt]').forEach(function (b) { b.classList.toggle('is-on', b === alt); });
      load(pickerUrl(slots[active], dlg.querySelector('[data-gbun-search] input').value.trim())); return;
    }
    var chip = e.target.closest('[data-gbun-chip]');
    if (chip) {
      dlg.querySelectorAll('[data-gbun-chip]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      var q = chip.getAttribute('data-gbun-chip'); dlg.querySelector('[data-gbun-search] input').value = q;
      window.fcTrack('bundle_search', { bundle: bundle.title, item: slots[active].label, query: q, chip: true });
      load(pickerUrl(slots[active], q)); return;
    }
    if (e.target.closest('[data-gbun-add2]')) { add(); return; }
    var ch = e.target.closest('[data-gbun-choose]'); if (ch) { openPicker(+ch.getAttribute('data-gbun-choose')); return; }
    if (e.target.closest('[data-gbun-dlgclose]') || e.target === dlg) { closePicker(); return; }
    if (e.target.closest('[data-gbun-more]') && nextUrl) { load(nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=bundle-picker', true); return; }
    var card = e.target.closest('[data-bp-card]');
    if (card && active > -1) {
      var item; try { item = JSON.parse(card.getAttribute('data-item')); } catch (err) { return; }
      if (item.phone) {
        closePicker();
        var po = document.querySelector('[data-phone-open]'); if (po) po.click();
        return;
      }
      if (slots[active].lock) item.v = item.v.filter(function (v) { return v.t === slots[active].lock; });
      if (/tough/i.test(slots[active].lock)) { var tu2 = /magsafe/i.test(slots[active].lock) ? (item.mtimg || item.timg) : item.timg; if (tu2) item.img = tu2; }
      if (!item.v || !item.v.length) return;
      slots[active].item = item; slots[active].vid = item.v[0].id;
      window.fcTrack('bundle_design_choose', { bundle: bundle.title, item: slots[active].label, product: item.title, kids: !!slots[active].useAlt, search: dlg.querySelector('[data-gbun-search] input').value.trim() });
      slots[active].side = item.pc ? defaultSide(slots[active]) : '';
      closePicker(); render();
      return;
    }
    var sd = e.target.closest('[data-gbun-side]');
    if (sd && !sd.disabled) { var a = sd.getAttribute('data-gbun-side').split(':'); slots[+a[0]].side = a[1]; render(); return; }
    if (e.target.closest('[data-gbun-add]')) add();
  });
  root.addEventListener('change', function (e) {
    var s = e.target.closest('[data-gbun-var]'); if (!s) return;
    slots[+s.getAttribute('data-gbun-var')].vid = +s.value; render();
  });
  dlg.querySelector('[data-gbun-search]').addEventListener('submit', function (e) {
    e.preventDefault(); var q = this.q.value.trim(); window.fcTrack('bundle_search', { bundle: bundle.title, item: slots[active].label, query: q }); load(pickerUrl(slots[active], q));
  });

  function add() {
    if (addBtn.disabled) return;
    var uid = 'b' + Date.now().toString(36);
    var items = slots.map(function (s) {
      var v = variant(s), props = {};
      if (v.p) for (var k in v.p) props[k] = v.p[k];
      if (s.item.pc) {
        var mode = sideMode(s);
        if (mode === 'choose' && s.side) props['Colour Sides'] = cap(s.side);
        else if (mode === 'quiet') { var ds = defaultSide(s); if (ds) props['Colour Sides'] = cap(ds); }
      }
      props.Bundle = bundle.title; props._bundle = uid;
      return { id: v.id, quantity: 1, properties: props };
    });
    var label = addBtn.innerHTML; addBtn.disabled = true; addBtn.classList.add('is-loading');
    fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        /* Each bundle has its own fixed-amount code; keep codes already in the cart so two different bundles both save. */
        if (!bundle.code) return null;
        return fetch(root_ + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var codes = (c.discount_codes || []).filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
          if (codes.indexOf(bundle.code) < 0) codes.push(bundle.code);
          return fetch(root_ + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
        }).catch(function () { return fetch(root_ + 'discount/' + encodeURIComponent(bundle.code), { credentials: 'same-origin' }).catch(function () {}); });
      })
      .then(function () {
        window.fcTrack('bundle_add', { bundle: bundle.title, items: items.length, value: (slots.reduce(function (t, s) { var v = variant(s); return t + (v ? v.c : 0); }, 0) - (bundle.saving || 0)) / 100, designs: slots.map(function (s) { return s.item ? s.item.title : ''; }).join(' | ') });
        addBtn.innerHTML = 'Added to your stocking';
        if (window.fcCart) { if (window.fcCart.refresh) window.fcCart.refresh(); if (window.fcCart.open) window.fcCart.open(); }
        setTimeout(function () { addBtn.innerHTML = label; addBtn.classList.remove('is-loading'); render(); }, 2500);
      })
      .catch(function (err) {
        addBtn.innerHTML = (err && err.description) || 'Could not add the bundle';
        setTimeout(function () { addBtn.innerHTML = label; addBtn.classList.remove('is-loading'); render(); }, 3000);
      });
  }
})();

/* Bundle cards flick through a few designs per item, so it reads as "any design". Only while on screen. */
(function () {
  'use strict';
  var items = [].slice.call(document.querySelectorAll('[data-gbun-flick]')).filter(function (el) { return el.children.length > 1; });
  if (!items.length || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var visible = new Set();
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); }); }, { rootMargin: '100px' });
    items.forEach(function (el) { io.observe(el); });
  } else items.forEach(function (el) { visible.add(el); });
  var tick = 0;
  setInterval(function () {
    tick++;
    items.forEach(function (el, n) {
      if (!visible.has(el) || (tick + n) % 2) return;   // stagger so the items don't all change together
      var imgs = el.children, cur = 0;
      for (var i = 0; i < imgs.length; i++) if (imgs[i].classList.contains('is-on')) cur = i;
      var nx = (cur + 1) % imgs.length;
      if (imgs[nx].loading === 'lazy') imgs[nx].loading = 'eager';
      imgs[cur].classList.remove('is-on'); imgs[nx].classList.add('is-on');
    });
  }, 1100);
})();

/* Click tracking across the guides: one listener, reads what was clicked from the page itself. */
(function () {
  'use strict';
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) : ''; }
  function pos(el) { return el && el.parentNode ? [].indexOf.call(el.parentNode.children, el) + 1 : 0; }
  function heading(el) { var sec = el.closest('section'); return sec ? txt(sec.querySelector('h1, h2')) : ''; }
  var page = location.pathname.replace(/^\/en-[a-z]{2}/, '');
  var guide = /\/pages\/(gifts-|christmas|stocking|secret-santa|personalised-gifts|f1-gifts|build-a-gift-bundle)/.test(page) || (window.fcXmas && fcXmas.mode === 'christmas' && page === '/');
  if (guide) window.fcTrack('guide_view', { guide: page === '/' ? 'homepage' : page.split('/').pop() });
  document.addEventListener('click', function (e) {
    var t = e.target, a;
    if ((a = t.closest('.grc-tile'))) return window.fcTrack('guide_tile_click', { tile: txt(a.querySelector('.grc-tile__label')), position: pos(a), section: heading(a), to: a.getAttribute('href') });
    if ((a = t.closest('.gshelf .prod-card a, .gshelf .prod-card'))) { var card = a.closest('.prod-card'); return window.fcTrack('shelf_product_click', { shelf: heading(card), product: txt(card.querySelector('h3')), position: pos(card) }); }
    if ((a = t.closest('.gshelf .sec-head a.all'))) return window.fcTrack('shelf_see_all', { shelf: heading(a), to: a.getAttribute('href') });
    if ((a = t.closest('.gshelf [data-bs-prev], .gshelf [data-bs-next], .gshelf [data-scroll-prev], .gshelf [data-scroll-next]'))) return window.fcTrack('shelf_scroll', { shelf: heading(a) });
    if ((a = t.closest('.ghero__jumps a'))) return window.fcTrack('guide_jump_click', { label: txt(a), position: pos(a) });
    if ((a = t.closest('.xnav a, .xcband a'))) return window.fcTrack('guide_nav_click', { label: txt(a), place: a.closest('.xnav') ? 'menu' : 'collection_band', position: pos(a) });
    if ((a = t.closest('.drawer .coll-card'))) return window.fcTrack('menu_trending_click', { label: txt(a), position: pos(a) });
    if ((a = t.closest('.xhero a.btn, .xhero .btn'))) return window.fcTrack('hero_button_click', { label: txt(a) });
    if ((a = t.closest('.gbud a, .gbud-tile'))) return window.fcTrack('budget_tile_click', { label: txt(a), position: pos(a.closest('.gbud-tile') || a) });
    if ((a = t.closest('[data-gf-results] .prod-card'))) return window.fcTrack('finder_result_click', { product: txt(a.querySelector('h3')), position: pos(a.closest('.gf-card') || a) });
    if ((a = t.closest('[data-gset-add]'))) { var gs = a.closest('[data-gset]'); return window.fcTrack('gift_set_add', { set: txt(gs && gs.querySelector('h2')), items: gs ? gs.querySelectorAll('[data-gset-on]:checked').length : 0 }); }
    if ((a = t.closest('.gfaq__item summary'))) return window.fcTrack('faq_open', { question: txt(a) });
  }, true);
})();
